import React from "react";
import { createRoot } from "react-dom/client";
import "assets/plugins/nucleo/css/nucleo.css";
import "assets/scss/argon-dashboard-react.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-slideshow-image/dist/styles.css";
import "swiper/css";
import "swiper/css/pagination";
import App from "./App";
import store from "./store/index";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

Sentry.init({
  dsn: "https://c2caefd837cb4d204141c178eb25506a@o4507571489210368.ingest.de.sentry.io/4507571504611408",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ToastContainer position="top-center" className="toast-font" />
        <App />
      </Provider>
    </QueryClientProvider>
  </>
);
